<template>
	<div style="background-color: #000">
		<Header title="订单详情" :haveHeight="false" url="transparent" :customEventRout="customEventRout"></Header>

		<div class="flex order_detail">
			<div class="detail_head">
				<div class="flex detail_title">
					<div
						class="time_box"
						v-if="
							(type == 1 &&
								!time_status &&
								detailsInfo.delivery_status == 0) ||
							(type == 3 &&
								!time_status &&
								detailsInfo.cancel_status == 0 &&
								detailsInfo.pay_status == 0)
						"
					>
						剩余{{ time[0] }}{{ time[1] }}分{{ time[2]
						}}{{ time[3] }}秒后自动取消
					</div>

					<div class="flex">
						<img
							v-if="type == 1"
							class="detail_title_icon"
							:src="
								'https://oss01.dayou.art/tresor-orderdetail-icon-' +
								(detailsInfo.delivery_status == 1
									? 'success'
									: detailsInfo.delivery_status == 2
									? 'overtime'
									: detailsInfo.delivery_status == 3
									? 'cancel'
									: 'wait') +
								'.png'
							"
						/>
						<img
							v-if="type == 2"
							class="detail_title_icon"
							:src="
								'https://oss01.dayou.art/tresor-orderdetail-icon-' +
								(detailsInfo.delivery_status == 1
									? 'success'
									: detailsInfo.delivery_status == 2
									? 'cancel'
									: 'buy') +
								'.png'
							"
						/>
						<img
							v-if="type == 3"
							class="detail_title_icon"
							:src="`https://oss01.dayou.art/tresor-orderdetail-icon-${
								detailsInfo.cancel_status == 0
									? detailsInfo.pay_status == 1
										? 'success'
										: 'wait'
									: detailsInfo.delivery_status == 1
									? 'overtime'
									: 'cancel'
							}.png`"
						/>

						<!-- 普通购买订单 -->
						<div class="detail_status" v-if="type == 1">
							{{
								detailsInfo.delivery_status == 1
									? '交易成功'
									: detailsInfo.delivery_status == 2
									? '超时取消'
									: detailsInfo.delivery_status == 3
									? '已取消'
									: '待支付'
							}}
						</div>
						<!-- 求购订单 -->
						<div class="detail_status" v-if="type == 2">
							{{
								detailsInfo.delivery_status == 1
									? '求购成功'
									: detailsInfo.delivery_status == 2
									? '求购失败，没有藏家同意转让'
									: '求购中，还没有藏家同意转让'
							}}
						</div>
						<!-- 盲盒订单 -->
						<div class="detail_status" v-if="type == 3">
							{{
								detailsInfo.cancel_status == 0
									? detailsInfo.pay_status == 1
										? '交易成功'
										: '待支付'
									: detailsInfo.cancel_status == 1
									? '超时取消'
									: '已取消'
							}}
						</div>
					</div>
				</div>
			</div>

			<div class="flex detail_content">
				<div class="common-wrap detail_card">
					<div class="list_item" v-if="type != 3">
						<div class="flex item_left">
							<div class="img_box">
								<img
									class="item_image"
									:src="detailsInfo.cover"
								/>
							</div>
							<!-- type==3 御首活动 cancel_status==0&&pay_status代表已支付 查看开盒结果 其余 查看活动详情 type不等于3查看数字文创详情 -->
							<div class="to_btn" @click="toDetail">
								查看数字文创详情>
							</div>
						</div>

						<div class="flex item_right_box">
							<div class="order_info">
								<div class="item_name text_over">
									{{
										detailsInfo.name || detailsInfo.nft_name
									}}
								</div>
								<div class="flex item_price">
									<div class="price">
										¥ {{ detailsInfo.fee }}
									</div>
								</div>
								<div class="info_item">
									<div class="item_labal">下单时间</div>
								</div>
								<div class="info_item">
									<div class="item_labal">订单编号</div>
								</div>
								<div class="info_item">
									<div class="item_labal">购买数量</div>
								</div>
								<div class="info_item">
									<div class="item_labal">总金额</div>
								</div>
							</div>

							<div class="item_right">
								<div
									class="item_desc text_over"
									style="line-height: 0.26rem; margin-top: 0"
								>
									数字文创·{{
										detailsInfo.resource_type == 1
											? '图片'
											: detailsInfo.resource_type == 2
											? '音频'
											: detailsInfo.resource_type == 3
											? '视频'
											: detailsInfo.resource_type == 4
											? '3D模型'
											: ''
									}}
								</div>
								<div
									class="item_desc text_over"
									style="line-height: 0.23rem"
								>
									创作者·{{
										detailsInfo.nick ||
										detailsInfo.nft_author
									}}
								</div>

								<div class="info_item">
									<div class="item_value">
										{{
											detailsInfo.order_time ||
											detailsInfo.time_timestamp ||
											detailsInfo.timestamp
										}}
									</div>
								</div>
								<div class="info_item">
									<div class="item_value">
										{{ detailsInfo.order_no }}
									</div>
								</div>
								<div
									class="info_item"
									style="margin-top: 0.18rem"
								>
									<div class="item_value">
										{{
											detailsInfo.unit ||
											detailsInfo.quantity
										}}
									</div>
								</div>
								<div class="info_item">
									<div class="item_price_bottom">
										¥
										{{
											detailsInfo.fee ||
											detailsInfo.total_fee
										}}
									</div>
								</div>
							</div>
						</div>
					</div>

					<div class="list_item" v-if="type == 3">
						<div class="flex item_left">
							<div class="img_box">
								<img
									class="item_image"
									:src="detailsInfo.image"
								/>
							</div>
							<!-- type==3 御首活动 cancel_status==0&&pay_status代表已支付 查看开盒结果 其余 查看活动详情 type不等于3查看数字文创详情 -->
							<div class="to_btn" @click="toDetail">
								{{
									detailsInfo.cancel_status == 0 &&
									detailsInfo.pay_status == 1
										? '查看盲盒开启结果>'
										: '查看活动详情>'
								}}
							</div>
						</div>

						<div class="flex item_right_box">
							<div class="order_info">
								<div class="item_name text_over">
									{{ detailsInfo.series_name }}
								</div>
								<div class="flex item_price">
									<div class="price">
										¥ {{ detailsInfo.total_fee }}
									</div>
								</div>

								<div class="info_item">
									<div class="item_labal">下单时间</div>
								</div>
								<div class="info_item">
									<div class="item_labal">订单编号</div>
								</div>
								<div class="info_item">
									<div class="item_labal">购买数量</div>
								</div>
								<div class="info_item">
									<div class="item_labal">总金额</div>
								</div>
							</div>

							<div class="item_right">
								<div
									class="item_name text_over"
									style="line-height: 0.26rem; margin-top: 0"
								>
									{{ detailsInfo.name }}
								</div>
								<div
									class="item_desc text_over"
									style="line-height: 0.23rem"
								>
									{{ detailsInfo.subname }}
								</div>

								<div class="info_item">
									<div class="item_value">
										{{
											detailsInfo.order_time ||
											detailsInfo.time_timestamp ||
											detailsInfo.timestamp
										}}
									</div>
								</div>
								<div class="info_item">
									<div class="item_value">
										{{ detailsInfo.order_no }}
									</div>
								</div>
								<div
									class="info_item"
									style="margin-top: 0.18rem"
								>
									<div class="item_value">
										{{
											detailsInfo.unit ||
											detailsInfo.quantity
										}}
									</div>
								</div>
								<div class="info_item">
									<div class="item_price_bottom">
										¥
										{{
											detailsInfo.fee ||
											detailsInfo.total_fee
										}}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<!-- delivery_status0待支付1支付2超时取消3取消，状态不同显示的按钮不同 -->
				<!-- type 1为购买的订单详情 2 为我的求购订单详情 -->
				<div class="detail_footer" v-if="type != 2 && !time_status">
					<!-- detailsInfo.cancel_status==0&&detailsInfo.pay_status==0&&type==3 待支付 御首 -->

					<div class="flex pay_btn_list">
						<div
							class="pay_btn cancel_btn_box"
							v-if="detailsInfo.delivery_status == 0 && type == 1"
							@click="_cancelOrder(detailsInfo.id)"
						>
							<div class="cancel_btn">取消订单</div>
						</div>
						<div
							v-if="
								(detailsInfo.delivery_status == 0 &&
									type == 1) ||
								(detailsInfo.cancel_status == 0 &&
									detailsInfo.pay_status == 0 &&
									type == 3)
							"
						>
							<div
								class="common-button pay_btn"
								@click="toPay"
								v-if="isRead"
							>
								支付
							</div>
							<div
								class="common-button pay_btn pay_btn_no"
								v-else
							>
								支付
							</div>
						</div>
						<div
							v-if="
								(type == 1 &&
									detailsInfo.delivery_status == 2) ||
								(type == 1 &&
									detailsInfo.delivery_status == 3) ||
								(type == 3 && detailsInfo.cancel_status > 0)
							"
							style="width: 100%"
						>
							<div
								class="common-button pay_btn pay_btn1"
								@click="toshop"
							>
								去购买
							</div>
						</div>
					</div>

					<div
						class="flex footer_procol"
						@click="selectRead"
						v-if="
							(detailsInfo.delivery_status == 0 && type == 1) ||
							(detailsInfo.cancel_status == 0 &&
								detailsInfo.pay_status == 0 &&
								type == 3)
						"
					>
						<div class="procol_point" v-if="!isRead"></div>
						<div class="procol_point_active" v-else></div>
						<div class="procol_text">
							我已阅读并同意
							<span @click.stop="to_procol">《大有空间数字文创购买协议》</span>
						</div>
					</div>
				</div>
			</div>
		</div>

		<payDailog
			v-show="showPayTypeDialog"
			:hide_zfb="true"
			@payType="getPayType"
			@close="showPayTypeDialog = false"
		></payDailog>
	</div>
</template>

<script>
import {
	cancelOrder,
	orderInfo,
	exchange_detail,
	apply_detail,
	transfer_pay,
	origin_pay,
} from '@/api/order';
import { formatMoney, get_time, toapp } from '@/utils/utils';
import { Toast } from 'vant';
import payDailog from '@/components/common/payDailog/payDailog';
export default {
	name: 'OrderDetail',
	components: {
		payDailog,
	},
	data() {
		return {
			id: 0,
			type: 0,

			detailsInfo: {
				delivery_status: 0,
				cover: '',
				name: '',
				nft_name: '',
				resource_type: 0,
				nick: '',
				nft_author: '',
				fee: '',
				order_time: '',
				time_timestamp: '',
				order_no: '',
				unit: '',
				quantity: '',
				id: '',
			},

			order: {
				d: '',
				h: '',
				m: '',
				s: '',
			},

			time: '',
			isRead: true,
			pay: 0,
			time_status: false,
			isPastDue: false,
			timeClone: '',
			blind_status: false,
			blind_type: 0,

			showPayTypeDialog: false, // 是否显示支付类型弹窗
			payType: 1, // 支付类型 （1：微信 2：支付宝）
		};
	},
	computed: {
		// 支付成功时跳转的页面路径
		redirect_url() {
			return `${location.origin}/pages/purchase_succeeded/purchase_succeeded?status=${this.type}&order_id=${this.id}`;
		},
	},
	created() {
		const options = this.$route.query;
		const id = options.id;
		const type = options.type;
		this.id = id;
		this.type = type;

		//type1为我购买的订单详情 2为我求购的订单详情
		if (type == 1) {
			this._orderInfo();
		} else if (type == 2) {
			this._apply_detail();
		} else if (type == 3) {
			this.exchange_detail();
		}
	},
    mounted () {
        // 将方法挂载window上，供安卓端调用
        window.handlePaySuccess = this.handlePaySuccess.bind(this);
        window.handlePayFail = this.handlePayFail.bind(this);
        window.handlePayCancel = this.handlePayCancel.bind(this);
    },
	methods: {
		//取消订单
		_cancelOrder(id) {
			cancelOrder({
				order_id: id,
			}).then(() => {
				this.$router.go(-1);
			});
		},

		//去购买
		toshop() { 
            toapp(8, this.detailsInfo.nft_id)
		},

		//是否阅读购买协议
		selectRead() {
			this.isRead = !this.isRead;
		},

		//购买订单详情
		_orderInfo() {
			orderInfo({ id: this.id }).then(async res => {
				const fee = res.fee / 100;
				res.fee = formatMoney(fee, 2);
				this.getEndOfRegistration(res.order_time * 1000, res.last_pay_time * 1000);
				res.order_time = get_time(
					res.order_time_format,
					res.order_time
				);
				this.detailsInfo = res;
			});
		},

		//盲盒订单详情
		exchange_detail() {
			exchange_detail({
				order_id: this.id,
			}).then(async res => {
				const fee = res.total_fee / 100;
				res.total_fee = formatMoney(fee, 2);
				this.getEndOfRegistration(res.timestamp, res.expire_timestamp);
				res.order_time = get_time(res.timestamp_format, res.timestamp);
				this.blind_status = this.blind_type == 1;
				this.blind_type = 0;
				this.detailsInfo = res;
			});
		},

		//求购订单详情
		_apply_detail() {
			apply_detail({
				id: this.id,
			}).then(res => {
				res.fee = (res.fee / 100).toFixed(2);
				res.time_timestamp = get_time(
					res.time_format,
					res.time_timestamp
				);
				res.delivery_status = res.transfer_status;
				res.resource_type = res.nft_type;
				this.detailsInfo = res;
			});
		},

		getEndOfRegistration(time, end) {
			// const start = new Date(new Date().toLocaleDateString());
            const start = new Date(time)
			start.setTime(time + 900 * 1000);
			const last_pay_time = end || start.getTime();
			// const { type , detailsInfo:{} } = this.data
			// const last_pay_time =new Date('2022/2/14 12:00:00').getTime()/1000
			var day, hour, minute, second;
			let data_time = (last_pay_time - new Date().getTime()) / 1000;
			var remaining_time = data_time > 0 ? data_time : 0;

			day = Math.floor(remaining_time / (60 * 60 * 24));
			remaining_time -= 60 * 60 * 24 * day;
			hour = Math.floor(remaining_time / (60 * 60));
			remaining_time -= 60 * 60 * hour;
			minute = Math.floor(remaining_time / 60);
			remaining_time -= 60 * minute;
			second = Math.floor(remaining_time);
			this.order.d = day ? (day + '').padStart(2, '0') : day;
			this.order.h = (hour + '').padStart(2, '0');
			this.order.m = (minute + '').padStart(2, '0');
			this.order.s = (second + '').padStart(2, '0');
			this.isPastDue = false;
			this.time_status = !minute && !second && !hour && !day;
			this.time = String(this.order.m) + String(this.order.s);
			if (!minute && !second && !hour && !day && this.type == 3) {
				const {
					detailsInfo: { cancel_status, pay_status },
				} = this;

				if (cancel_status == 0 && pay_status == 0) {
					this.detailsInfo.cancel_status = 1;
				}
			}
			this.timer = setTimeout(() => {
				this.getEndOfRegistration(time, last_pay_time);
			}, 1000);
		},

		toDetail() {
			// const {
			// 	detailsInfo: { nft_id, goods_bind_id },
			// 	type,
			// } = this;
			// let url;
			// if (type == 3) {
			// 	//御首活动
			// 	//求购流程未完善 暂时跳转到活动页
			// 	url = `/pages/yushou/blind_box_activity/blind_box_activity?goods_bind_id=${goods_bind_id}`;
			// } else {
			// 	//求购流程未完善 暂时跳转到商品详情页
			// 	url = `/pages/works_detail/works_detail?id=${nft_id}&type=0`;
			// }
			const {
				detailsInfo: { nft_id },
			} = this;
			toapp(8, `${nft_id}`);
		},

		toPay() {
			const { type } = this;

			if (type == 1) {
				this._orderPurchase();
			} else if (type == 2) {
				this._orderTransfer();
			}
		},

		_orderTransfer() {
			this.showPayTypeDialog = true;
		},

		_orderPurchase() {
			this.showPayTypeDialog = true;
		},

		// 获取支付方式
		getPayType({ type }) {
			this.payType = type && +type;
			this.showPayTypeDialog = false;
			Toast.loading({
				message: '支付中...',
				forbidClick: true,
			});
			this.get_payment_parame(this.id);
		},

		// 获取支付参数
		get_payment_parame(order_id) {
			const params = {
				order_id,
				pay_platform: this.payType, // 支付平台微信、支付宝
				pay_type: 'app', // 支付方式 h5/minipro/jsapi/app
				redirect_url: this.redirect_url, // 支付成功跳转成功地址
				quit_url: `${location.href}`, // 支付失败跳回当前地址
			};

			const fn = this.is_sell_out ? transfer_pay : origin_pay; // 执行的接口名
			fn(params)
				.then((data) => {
     //                data = data.data
     //                data.prepayId = data.prepayid
     //                data.partnerId = data.partnerid
					// data.pay_platform = this.payType;
					// data.package_android = data.package;
					
					data.prepayId = data.prepayid;
					data.partnerId = data.partnerid;
					data.pay_platform = this.payType;
					data.package_android = data.package;
					toapp(3, JSON.stringify(data));
					
					// console.log(JSON.stringify(data))
					// toapp(3, JSON.stringify(data));
				})
				.catch(err => {
					// console.error(err);
					Toast.fail(err.msg);
				});
		},

        // 跳转购买协议
        to_procol () {
            this.$router.push({
                name: 'purchase'
            })
        },

        // 自定义头部后退方法
        customEventRout () {
            // 判断是否是从购买页支付成功后跳转而来的
            this.$route.query.isBuy
                ? toapp(1)
                : this.$router.go(-1)
        },

        // 处理支付成功后的逻辑
        handlePaySuccess () {
            Toast('支付成功');

            const type = this.$route.query.type;
            if (type == 1) {
                this._orderInfo();
            } else if (type == 2) {
                this._apply_detail();
            } else if (type == 3) {
                this.exchange_detail();
            }
        },

        // 处理支付失败后的逻辑
        handlePayFail (error) {
            Toast(error);
        },

        // 处理支付取消后的逻辑
        handlePayCancel () {
            Toast('支付已取消');
        },
	},
};
</script>

<style lang="less" scoped>
@import './order_detail.less';
</style>
